import { z } from 'zod';

// Checkout form validation schema
export const checkoutSchema = z.object({
  firstName: z.string()
    .trim()
    .min(1, { message: "Le prénom est requis" })
    .max(50, { message: "Le prénom doit faire moins de 50 caractères" }),
  lastName: z.string()
    .trim()
    .min(1, { message: "Le nom est requis" })
    .max(50, { message: "Le nom doit faire moins de 50 caractères" }),
  email: z.string()
    .trim()
    .email({ message: "Email invalide" })
    .max(255, { message: "L'email doit faire moins de 255 caractères" }),
  phone: z.string()
    .trim()
    .min(1, { message: "Le téléphone est requis" })
    .regex(/^[0-9+\-\s()]*$/, { message: "Format de téléphone invalide" })
    .max(20, { message: "Le téléphone doit faire moins de 20 caractères" }),
  billingAddress: z.string()
    .trim()
    .min(1, { message: "L'adresse de facturation est requise" })
    .max(500, { message: "L'adresse doit faire moins de 500 caractères" }),
  shippingAddress: z.string()
    .trim()
    .max(500, { message: "L'adresse doit faire moins de 500 caractères" })
    .optional()
    .or(z.literal('')),
  sameAddress: z.boolean(),
});

export type CheckoutFormData = z.infer<typeof checkoutSchema>;
